import { createAction, props } from '@ngrx/store';
import { LobbyEntryDetail, ProvidedService } from 'src/app/lobby/shared/models/lobby-entry-detail';
import { LobbyServiceWithCategory } from 'src/app/lobby/shared/models/lobby-service';
import { LobbyServiceCheckList } from 'src/app/lobby/shared/models/lobby-service-checklist';

export const assistLobbyEntrySuccess = createAction(
    '[Wrap Up API] Assist Lobby Entry Success',
    props<{ lobbyEntryDetail: LobbyEntryDetail,showLobbyCategory:boolean,isImpersonateAssist:boolean|false,impersonateByName:string|null }>()
);
export const impersonateAssistLobbyEntrySuccess = createAction(
    '[Wrap Up API] Impersonate Assist Lobby Entry Success',
  props<{ lobbyEntryDetail: LobbyEntryDetail, showLobbyCategory: boolean, isImpersonateAssist: boolean, impersonateByName: string | null, impersonatedByCode: string | null }>()
);

export const assistLobbyEntryFailure = createAction(
    '[Wrap Up API] Assist Lobby Entry Fail',
    props<{error: string}>()
);
export const impersonateAssistLobbyEntryFailure = createAction(
    '[Wrap Up API] Impersonate Assist Lobby Entry Fail',
    props<{error: string}>()
);

export const loadServicesSuccess = createAction(
    '[Wrap Up API] Load Services Success',
    props<{services: LobbyServiceWithCategory[]}>()
);

export const loadServicesFailure = createAction(
    '[Wrap Up API] Load Services Fail',
    props<{error: string}>()
);

export const backToLobbySuccess = createAction(
    '[Wrap Up API] Back to Lobby Success',
    props<{services: LobbyServiceWithCategory[],isImpersonateAssist:boolean}>()
);

export const backToLobbyFailure = createAction(
    '[Wrap Up API] Back to Lobby Fail',
    props<{error: string}>()
);

export const fetchLobbyEntrySuccess = createAction(
    '[Wrap Up API] Fetch Lobby Entry Success',
    props<{ lobbyEntryDetail: LobbyEntryDetail }>()
);

export const fetchLobbyEntryFailure = createAction(
    '[Wrap Up API] Fetch Lobby Entry Fail',
    props<{error: string}>()
);

export const provideServiceSuccess = createAction(
    '[Wrap Up API] Provide Service Success',
    props<{providedServices: ProvidedService[]}>()
);

export const provideServiceFailure = createAction(
    '[Wrap Up API] Provide Service Fail',
    props<{error: string}>()
);

export const updateProvideServiceReferenceSuccess = createAction(
    '[Wrap Up API] Update Provide Service Reference Success',
    props<{providedServices: ProvidedService[]}>()
);

export const updateProvideServiceReferenceFailure = createAction(
    '[Wrap Up API] Update Provide Service Reference Fail',
    props<{error: string}>()
);

export const removeProvideServiceSuccess = createAction(
    '[Wrap Up API] Remove Provide Service Success',
    props<{providedServices: ProvidedService[]}>()
);

export const removeProvideServiceFailure = createAction(
    '[Wrap Up API] Remove Provide Service Fail',
    props<{error: string}>()
);

export const getCheckListForServiceeSuccess = createAction(
    '[Wrap Up API] Get Check List For Service Success',
    props<{checkList: LobbyServiceCheckList[]}>()
);

export const getCheckListForRequestedServiceeSuccess = createAction(
    '[Wrap Up API] Get Check List For Requested Service Success',
    props<{checkList: LobbyServiceCheckList[]}>()
);

export const getCheckListForServiceFailure = createAction(
    '[Wrap Up API] Get Check List For Service Fail',
    props<{error: string}>()
);

export const wrapUpSuccess = createAction(
    '[Wrap Up API] Wrap Up Success'
);

export const wrapUpFailure = createAction(
    '[Wrap Up API] Wrap Up Fail',
    props<{error: string}>()
);

export const isVisitorArrivedSuccess = createAction(
    '[Wrap Up API] Set Visitor Arrive Success'
);

export const isVisitorArrivedFailure = createAction(
    '[Wrap Up API] Set Visitor Arrive Fail',
    props<{error: string}>()
);
